import { render } from "./SettingsChangeEmailModal.vue?vue&type=template&id=3a7c23ed&ts=true"
import script from "./SettingsChangeEmailModal.vue?vue&type=script&lang=ts"
export * from "./SettingsChangeEmailModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__